import React from "react";

import { connect } from 'react-redux';
import UserGroupComponent from './UserGroupComponent';
import { teamProfileOperations } from './duck';
import { userManagementOperations } from '../UserManagement/duck';

const mapStateToProps = ({ locationReducer, appReducer, teamProfileReducer}) => {
  return {
    locationId: locationReducer.location_code,
    channels: appReducer.channels.data,
  };
};

const mapDispatchToProps = (dispatch) => {

    const removeChannelFromUserDispatch= (userId, channelId) => {
      dispatch(teamProfileOperations.removeChannelFromUserOperation(userId, channelId));
    }

    const changeChannelForUserDispatch = (userId, oldChannelId, newChannelId) => {
      dispatch(teamProfileOperations.addChannelToUserOperation(userId, newChannelId));
      dispatch(teamProfileOperations.removeChannelFromUserOperation(userId, oldChannelId));
    }

    const addChannelToUserDispatch = (userId, channelId) => {
      dispatch(teamProfileOperations.addChannelToUserOperation(userId, channelId));
    }

    return {removeChannelFromUserDispatch, changeChannelForUserDispatch, addChannelToUserDispatch};
};

const UserGroupContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserGroupComponent);

export default UserGroupContainer;
